const $ = window.jQuery;
const $window = window.$window || $(window);

function fixTocOffest($toc, headerHeight, adminbarHeight) {
	const offsetHeight = adminbarHeight + headerHeight + 20;
	$toc.css('top', offsetHeight);
}

function initToc() {
	const $toc = $('[data-toc]');
	if (!$toc.length) return;

	const headerHeight = $('#header').outerHeight();
	const adminbar = $('#wpadminbar');

	let adminbarHeight = 0;

	if (adminbar[0]) {
		adminbarHeight = adminbar.outerHeight();
	}

	// foreach link in toc check if the anchor tag heading element is in viewport to add the active state to the link
	const tocLinks = $toc.find('[data-toc-list-item] a');
	const scrollItems = tocLinks.map(function () {
		const item = $(this.hash);
		if (item.length) {
			return item;
		}
	});

	// First, remove active state from all links
	tocLinks.parent().attr('data-active', false);

	// Create a new Intersection Observer instance
	let observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					// If the item is in the viewport, make the corresponding link active
					tocLinks
						.filter('[href="#' + entry.target.id + '"]')
						.parent()
						.attr('data-active', true);
				} else {
					// If the item is not in the viewport, remove the active state
					tocLinks
						.filter('[href="#' + entry.target.id + '"]')
						.parent()
						.attr('data-active', false);
				}
			});
		},
		{ threshold: [0], rootMargin: '-100px 0px -200px 0px' }
	);

	// Observe each scrollItem
	scrollItems.each(function () {
		observer.observe($(this)[0]);
	});

	$window.scroll(function () {
		fixTocOffest($toc, headerHeight, adminbarHeight);
	});

	$window.resize(function () {
		fixTocOffest($toc, headerHeight, adminbarHeight);
	});

	$window.on('load', function () {
		fixTocOffest($toc, headerHeight, adminbarHeight);
	});
}

function initMobileToc() {
	const $toc = $('[data-mobile-toc]');
	if (!$toc.length) return;

	const $tocButton = $('[data-mobile-toc-toggle]');
	const $tocInner = $toc.find('.inner');

	$tocButton.on('click', function () {
		$tocButton.toggleClass('active');
		$tocInner.toggleClass('active');

		if ($tocInner.hasClass('active')) {
			$tocInner.attr('aria-hidden', 'false');
			$tocButton.text('Dölj innehållsförteckning');
		} else {
			$tocInner.attr('aria-hidden', 'true');
			$tocButton.text('Visa innehållsförteckning');
		}
	});
}

export { initToc, initMobileToc };
